import { render } from "./Message.vue.js?vue&type=template&id=487d671c&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Message.vue?vue&type=template&id=487d671c&scoped=true"
import script from "./Message.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Message.vue?vue&type=script&lang=js"

import "./Message.vue.scss?vue&type=style&index=0&id=487d671c&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Message.vue?vue&type=style&index=0&id=487d671c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487d671c"],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/Message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "487d671c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('487d671c', __exports__)) {
    api.reload('487d671c', __exports__)
  }
  
  module.hot.accept("./Message.vue.js?vue&type=template&id=487d671c&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Message.vue?vue&type=template&id=487d671c&scoped=true", () => {
    api.rerender('487d671c', render)
  })

}


export default __exports__